var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('b-spinner'):_c('NewsPostList',{attrs:{"sectionTitle":_vm.sectionTitle,"sectionSlug":_vm.headingLink ? _vm.sectionSlug : null,"postList":_vm.posts,"totalPosts":_vm.total,"perPage":_vm.perPage,"headingTag":_vm.headingTag}})}
var staticRenderFns = []

export { render, staticRenderFns }